import { Link } from "react-router-dom";
import { Loader2 } from "lucide-react";

export const REL = { planning_only: "Planning uniquement", interest: "Intérêt exprimé", contact_requested: "Contact demandé", in_progress: "Échange en cours", client: "Client" };
export const TSTATUS = { open: "Ouverte", in_progress: "En cours", resolved: "Résolue", closed: "Clôturée" };
export const PRIO = { low: "Basse", normal: "Normale", high: "Haute" };
export const ACTION = {
  admin_login: "Connexion administrateur", account_suspended: "Compte suspendu", account_reactivated: "Compte réactivé",
  account_deleted: "Compte supprimé", account_export: "Export du compte", export_csv: "Export CSV", member_role: "Rôle modifié",
  member_status: "Accès membre modifié", invite_resend: "Invitation renvoyée", crm_update: "Suivi AVELIS modifié",
  reset_link: "Lien de réinitialisation", user_update: "Utilisateur modifié", settings: "Paramètres", ticket_reply: "Réponse assistance",
  ticket_update: "Demande mise à jour", support_requested: "Accès support demandé", support_accepted: "Accès support autorisé",
  support_refused: "Accès support refusé", support_opened: "Mode support ouvert", support_closed: "Mode support fermé",
  support_expired: "Mode support expiré", support_write_blocked: "Modification bloquée (support)", support_revoked_by_team: "Accès retiré par l'équipe",
};

export const fmt = (s, time = false) => {
  if (!s) return "—";
  const d = new Date(s);
  return time ? d.toLocaleString("fr-BE", { dateStyle: "short", timeStyle: "short" }) : d.toLocaleDateString("fr-BE");
};

export function Badge({ tone = "slate", children, testid }) {
  const t = { slate: "bg-slate-100 text-slate-600", green: "bg-emerald-100 text-emerald-800", red: "bg-red-100 text-red-700", amber: "bg-amber-100 text-amber-800", teal: "bg-teal-100 text-teal-800" }[tone];
  return <span className={`inline-flex items-center whitespace-nowrap rounded-full px-2.5 py-0.5 text-[11px] font-bold ${t}`} data-testid={testid}>{children}</span>;
}

export function StatusBadge({ status }) {
  return status === "suspended" ? <Badge tone="red">Suspendu</Badge> : <Badge tone="green">Actif</Badge>;
}

export function Page({ title, subtitle, actions, children, testid }) {
  return (
    <div data-testid={testid} className="fade-up">
      <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
        <div><h1 className="text-2xl font-bold text-slate-900 sm:text-3xl">{title}</h1>{subtitle && <p className="mt-1 text-sm text-slate-500">{subtitle}</p>}</div>
        {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
      </div>
      {children}
    </div>
  );
}

export function Spinner() {
  return <div className="flex justify-center py-16 text-teal-700" data-testid="admin-loading"><Loader2 className="h-6 w-6 animate-spin" /></div>;
}

export function ErrorBox({ error }) {
  return <div className="rounded-xl border border-red-200 bg-red-50 p-4 text-sm text-red-700" data-testid="admin-error">{error}</div>;
}

export function EmptyBox({ text, children }) {
  return <div className="rounded-2xl border border-dashed border-slate-300 p-8 text-center text-sm text-slate-500" data-testid="admin-empty">{text}{children && <div className="mt-3">{children}</div>}</div>;
}

export function Card({ title, children, action, className = "" }) {
  return (
    <section className={`card p-5 ${className}`}>
      {(title || action) && <div className="mb-3 flex items-center justify-between gap-2"><h2 className="text-sm font-bold uppercase tracking-wide text-slate-500">{title}</h2>{action}</div>}
      {children}
    </section>
  );
}

export function AccountLink({ id, name }) {
  return <Link to={`/admin/comptes/${id}`} className="font-semibold text-teal-800 hover:underline">{name}</Link>;
}

export function Pager({ page, total, per, setPage }) {
  const pages = Math.max(1, Math.ceil(total / per));
  if (pages <= 1) return null;
  return (
    <div className="mt-4 flex items-center justify-center gap-3 text-sm" data-testid="admin-pager">
      <button className="btn-ghost !min-h-[36px] !px-3" disabled={page <= 1} onClick={() => setPage(page - 1)} data-testid="pager-prev">Précédent</button>
      <span>Page {page} / {pages}</span>
      <button className="btn-ghost !min-h-[36px] !px-3" disabled={page >= pages} onClick={() => setPage(page + 1)} data-testid="pager-next">Suivant</button>
    </div>
  );
}
